import { render } from "./Sucursal.vue?vue&type=template&id=af3e9ae4&scoped=true"
import script from "./Sucursal.vue?vue&type=script&lang=js"
export * from "./Sucursal.vue?vue&type=script&lang=js"

import "./Sucursal.vue?vue&type=style&index=0&id=af3e9ae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3e9ae4"]])

export default __exports__